// External
import { Routes } from '@angular/router';

// Internal
import { AppOrganiserComponent } from './app.organiser.component';
import { RedirectGuard } from '../common/services/guards/redirect.guard';
import { SupportGuard } from '../common/services/guards/support.guard';
import { ParentalGuard } from '../common/services/guards/parental.guard';
import { DevicesGuard } from '../common/services/guards/devices.guard';
import { PrivacyGuard } from '../common/services/guards/privacy.guard';
import { PremiumResolver } from '../common/services/resolvers/premium.resolver';
import { PrivacyResolver } from '../common/services/resolvers/privacy.resolver';
import { RedirectNccGuard } from '../common/services/guards/redirect-ncc.guard';
import { ATOGuard } from '../common/services/guards/ato.guard';
import { ATODevicesGuard } from '../common/services/guards/ato-devices.guard';

export const AppOrganiserRoutes: Routes = [
    {
        path: '',
        component: AppOrganiserComponent,
        pathMatch: 'prefix',
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./../pages/dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [],
                runGuardsAndResolvers: 'always',
                pathMatch: 'full',
                data: {
                    routeName: '_dashboard'
                }
            },
            {
                path: 'dashboard',
                loadChildren: () => import('./../pages/dashboard/organiser/dashboard.organiser.module').then(m => m.DashboardOrganiserModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'family',
                loadChildren: () => import('../pages/family/family.module').then(m => m.FamilyModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'full'
            },
            {
                path: 'privacy',
                loadChildren: () => import('./../pages/privacy/organiser/privacy.organiser.module').then(m => m.PrivacyOrganiserModule),
                canActivate: [PrivacyGuard],
                resolve: { data: PrivacyResolver },
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'support',
                loadChildren: () => import('./../pages/support/support.module').then(m => m.SupportModule),
                canActivate: [SupportGuard],
                runGuardsAndResolvers: 'pathParamsChange',
                pathMatch: 'full'
            },
            {
                path: 'support',
                loadChildren: () => import('./../pages/support/organiser/support.organiser.module').then(m => m.SupportOrganiserModule),
                canActivate: [SupportGuard],
                runGuardsAndResolvers: 'pathParamsChange',
                pathMatch: 'prefix'
            },
            {
                path: 'premium',
                loadChildren:  () => import('./../pages/premium/premium.module').then(m => m.PremiumModule),
                canActivate: [],
                resolve: { data: PremiumResolver },
                runGuardsAndResolvers: 'always',
                pathMatch: 'full'
            },
            {
                path: 'subscriptionsv3',
                redirectTo: 'subscriptionsv3/services',
                pathMatch: 'full',
                data: {
                    routeName: '_subscriptionsv3'
                }
            },
            {
                path: 'subscriptionsv3',
                loadChildren: () => import('./../pages/subscriptions-v3/subscriptions-v3.module').then(m => m.SubscriptionsV3Module),
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },

            {
                path: 'subscriptions',
                redirectTo: 'subscriptions/services',
                pathMatch: 'full',
                data: {
                    routeName: '_subscriptions'
                }
            },
            {
                path: 'subscriptions',
                loadChildren: () => import('./../pages/subscriptions/organiser/subscriptions.organiser.module').then(m => m.SubscriptionsOrganiserModule),
                // canActivate: [CombinedMainGuard, SubscriptionsGuard],
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'subscriptions',
                redirectTo: '/subscriptions/services',
                pathMatch: 'full',
                data: {
                    routeName: '_subscriptions'
                }
            },
            {
                path: 'devices',
                loadChildren: () => import('./../pages/devices/devices.module').then(m => m.DevicesModule),
                canActivate: [ATODevicesGuard],
                runGuardsAndResolvers: 'always',
                pathMatch: 'full'
            },
            {
                path: 'devices/:deviceCrc/details',
                loadChildren: () => import('./../pages/devices/devices-details/devices-details.module').then(m => m.DevicesDetailsModule),
                canActivate: [DevicesGuard],
                runGuardsAndResolvers: 'always',
                pathMatch: 'full'
            },
            {
                path: 'parentalncc',
                loadChildren: () => import('../pages/parental-ncc/list-profiles/list-profiles.module').then(m => m.ListProfilesModule),
                pathMatch: 'full'
            },
            {
                path: 'parentalncc/:child',
                redirectTo: 'parentalncc/:child/dashboard',
                pathMatch: 'full'
            },
            {
                path: 'parentalncc/:child',
                loadChildren: () => import('./../pages/parental-ncc/organiser/parental-ncc.organiser.module').then(m => m.ParentalNccOrganiserModule),
                canActivate: [RedirectNccGuard],
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'parental/settings',
                loadChildren: () => import('./../pages/parental/settings/settings.module').then(m => m.ParentalSettingsModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'full'
            },
            {
                path: 'account',
                loadChildren: () => import('./../pages/account/organiser/account.organiser.module').then(m => m.AccountOrganiserModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'

            },
            {
                path: 'social',
                redirectTo: 'parental',
                pathMatch: 'full'
            },
            {
                path: 'parentaladvisor',
                redirectTo: 'parental',
                pathMatch: 'prefix'
            },
            {
                path: 'parental',
                loadChildren: () => import('./../pages/parental/parental.module').then(m => m.ParentalModule),
                canActivate: [RedirectGuard, ParentalGuard],
                runGuardsAndResolvers: 'always',
                pathMatch: 'full'
            },
            {
                path: 'parental/:child',
                loadChildren: () => import('./../pages/parental/parental.module').then(m => m.ParentalModule),
                canActivate: [RedirectGuard, ParentalGuard],
                runGuardsAndResolvers: 'always',
                pathMatch: 'full'
            },
            {
                path: 'parental/:child',
                loadChildren: () => import('./../pages/parental/organiser/parental.organiser.module').then(m => m.ParentalOrganiserModule),
                canActivate: [RedirectGuard, ParentalGuard],
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'offers',
                loadChildren: () => import('./../pages/offers/offers.module').then(m => m.OffersModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'full'
            },
            {
                path: 'account',
                loadChildren: () => import('./../pages/account/organiser/account.organiser.module').then(m => m.AccountOrganiserModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'referral',
                loadChildren: () => import('./../pages/referral/referral.module').then(m => m.ReferralModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'vpn',
                loadChildren: () => import('./../pages/vpn/vpn.module').then(m => m.VpnModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'passwordmanager',
                loadChildren: () => import('./../pages/password-manager/password-manager.module').then(m => m.PasswordManagerModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'securepass',
                loadChildren: () => import('./../pages/secure-pass/secure-pass.module').then(m => m.SecurePassModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'idtheftprotection',
                loadChildren: () => import('./../pages/idtheftprotection/idtheftprotection.module').then(m => m.IdtheftprotectionModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'security',
                loadChildren: () => import('./../pages/security/organiser/security.organiser.module').then(m => m.SecurityOrganiserModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'business',
                loadChildren: () => import('../pages/business/business.module').then(m => m.BusinessModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'full'
            },
            {
                path: 'business',
                loadChildren: () => import('./../pages/business/organiser/business.organiser.module').then(m => m.BusinessOrganiserModule),
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            },
            {
                path: 'ato/setup',
                loadChildren: () => import('../pages/ato/setup/ato-setup.module').then(m => m.AtoSetupModule),
                canActivate: [ATOGuard],
                runGuardsAndResolvers: 'always',
                pathMatch: 'full'
            },
            {
                path: 'ato',
                loadChildren: () => import('../pages/ato/organiser/ato.organiser.module').then(m => m.AtoOrganiserModule),
                canActivate: [ATOGuard],
                runGuardsAndResolvers: 'always',
                pathMatch: 'prefix'
            }
        ]
    }
];
